(() => {
  if (window.nsProductMotion) return;
  window.nsProductMotion = true;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const effects = new Set();
  const canObserve = 'IntersectionObserver' in window;

  function syncVideo(video) {
    if (video.dataset.nsGalleryManaged === 'true') return;
    const shouldPlay = video.dataset.nsAutoplay === 'true' &&
      video.dataset.nsVideoLoaded === 'true' && video.dataset.nsInView === 'true' &&
      !document.hidden && !preference.matches;
    if (shouldPlay) video.play().catch(() => {});
    else video.pause();
  }

  function loadVideo(video) {
    if (video.dataset.nsVideoLoaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.nsVideoLoaded = 'true';
    video.load();
    syncVideo(video);
    video.dispatchEvent(new CustomEvent('ns:video-ready', { bubbles: true }));
  }

  const nearObserver = canObserve ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      loadVideo(entry.target);
      nearObserver.unobserve(entry.target);
    });
  }, { rootMargin: '250px', threshold: 0 }) : null;

  const playbackObserver = canObserve ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.dataset.nsInView = String(entry.isIntersecting);
      syncVideo(entry.target);
    });
  }, { threshold: 0.05 }) : null;

  function reveal(element) {
    if (element.dataset.nsRevealed === 'true') return;
    element.dataset.nsRevealed = 'true';
    if (preference.matches || typeof element.animate !== 'function') return;
    // Animate pixels only. Never change section height or scroll position.
    const effect = element.animate([
      { opacity: 0, transform: 'translateY(12px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 440, easing: 'cubic-bezier(0.2, 0.65, 0.3, 1)' });
    effects.add(effect);
    effect.finished.then(() => effects.delete(effect), () => effects.delete(effect));
  }

  const revealObserver = canObserve ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      revealObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -24px 0px', threshold: 0.05 }) : null;

  const revealSelectors = [
    '.product__title', '.ns-product-details .ns-product-details__accordion', '.ns-loop-gallery__header',
    '.ns-benefits__intro', '.ns-benefits__row', '.ns-why-pick__header',
    '.ns-why-pick__card', '.ns-reviews__summary', '.ns-reviews__card',
    '.ns-faq h2', '.ns-faq__item'
  ].join(',');

  function initialize(root = document) {
    root.querySelectorAll('video[data-ns-lazy-video]').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      video.controls = preference.matches || video.dataset.nsControls === 'true';
      if (nearObserver) {
        nearObserver.observe(video);
        playbackObserver.observe(video);
      } else {
        video.dataset.nsInView = 'true';
        loadVideo(video);
      }
    });
    root.querySelectorAll(revealSelectors).forEach(element => {
      if (!element.closest('#MainContent') || element.dataset.nsRevealObserved) return;
      element.dataset.nsRevealObserved = 'true';
      if (revealObserver) revealObserver.observe(element);
      else reveal(element);
    });
  }

  document.addEventListener('visibilitychange', () => {
    videos.forEach(video => {
      if (document.hidden) video.pause();
      else syncVideo(video);
    });
  });
  preference.addEventListener('change', () => {
    effects.forEach(effect => effect.cancel());
    videos.forEach(video => {
      video.controls = preference.matches || video.dataset.nsControls === 'true';
      syncVideo(video);
    });
  });
  window.addEventListener('pagehide', () => videos.forEach(video => video.pause()));
  window.addEventListener('pageshow', () => videos.forEach(syncVideo));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    videos.forEach(video => {
      if (!event.target.contains(video)) return;
      nearObserver?.unobserve(video);
      playbackObserver?.unobserve(video);
      video.pause();
      videos.delete(video);
    });
    event.target.querySelectorAll(revealSelectors).forEach(element => revealObserver?.unobserve(element));
  });
  initialize();
})();
